import React, { Component } from 'react';
import irelandApi from '../../../irelandApi';
import ArrowButton from '../../common/button-arrow';
import { Link } from 'react-router-dom';
import Truncate from 'react-truncate';

import './latest-news.css';

class LatestNews extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: []
    };
  }

  componentDidMount = () => {
    irelandApi.get('/api/articles')
      .then(res => {
        let data = res.data.data.filter(article => article.attributes.featured);
        let data_sort = data.sort((a, b) => {
          return Date.parse(b.attributes['display-from-date']) - Date.parse(a.attributes['display-from-date']);
        });
        let data_slice = data_sort.slice(0, 3);

        this.setState({
            data: data_slice
        });
      });
  }

  render() {
    return (
      <div className="container latest-news">
        <div className="heading-container">
          <h2>Latest News</h2>
          <Link to={'/latest-news'}>
            <ArrowButton arrow={false} color='grey' submit={false}>VIEW ALL</ArrowButton>
          </Link>
        </div>
        <div className="articles-container">
          {this.state.data.length > 0 &&
            this.state.data.map((article, key) => (
              <Link className="article" key={key} to={`/article/${article.id}`}>
                <img src={article.attributes.link.image} alt={article.attributes.title} />
                <div className="article-item-title">
                  <div>
                    <Truncate
                      lines={2}
                      ellipsis='...'>
                        {article.attributes.title}
                    </Truncate>
                  </div>
                </div>
              </Link>
            ))
          }
        </div>
      </div>
    );
  }
}

export default LatestNews;



// WEBPACK FOOTER //
// ./src/components/home/latest-news/latest-news.jsx